module.exports = __webpack_public_path__ + "static/img/son7_active.bf948d75.jpg";